var styles = {"root":"Header_root__VQJBt","landscape":"Header_landscape__1h97E","dateWrapper":"Header_dateWrapper__2H5ir","day":"Header_day__3Yl1b","wrapper":"Header_wrapper__14CGB","blank":"Header_blank__3hje1","active":"Header_active__nfkku","year":"Header_year__3YOb_","date":"Header_date__3JLwu","range":"Header_range__3jO9j"};

export default styles;
